import React from "react";
import classNames from "classnames";
import style from "./index.module.scss";
import { Link, useHistory } from "react-router-dom";

interface Props {
    src: string;
    text: string;
    notice?: boolean;
}

const Index = ({ src, text, notice = false }: Props) => {
    const history = useHistory();

    function isMatch(path: string) {
        return history.location.pathname.includes(src);
    }

    return (
        <Link
            replace
            className={classNames(style.link, {
                [style.current]: isMatch("/" + src)
            })}
            to={src}>
            {notice && <i className={style.notice} />}
            {text}
        </Link>
    );
};

export default Index;
